import React from "react";

import DateSection from "../Cards/CardComponents/DateSection";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import ImageSection from "../Common/ImageSection_courosel";
import parse from "html-react-parser";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

const Details = ({ particularEvent }) => {
  const mainSection = particularEvent?.mainSection || {};
  const eventDateTime = particularEvent?.eventDateTime;
  const location = mainSection?.location || {};

  return (
    <div className="bg-inherit p-6 rounded-lg mx-auto pb-6 sm:pb-18">
      <div className="flex flex-col md:flex-row items-start justify-start">
        <div className="pl-4 sm:pl-14 sm:pr-16 mb-2">
          {!!particularEvent?.attendeeStatusText && (
            <div className="absolute w-fit h-[32px] bg-[#e59419] text-white text-sm font-medium px-3 pt-1 rounded-br-[24px] rounded-tl-[16px] z-10 font-poppins flex items-center">
              <TrendingUpIcon className="mr-2" />
              <span className="mr-4">{particularEvent.attendeeStatusText}</span>
            </div>
          )}
          <ImageSection imagesa={mainSection?.imageInfoList} />
        </div>

        {/* Content Section */}
        <div className="px-4 sm:max-w-[40vw] flex flex-col items pt-4 pr-8">
          <DateSection eventDateTime={eventDateTime} />
          <h2 className="text-[clamp(1.25rem,4vw,2rem)] md:text-[1.8vw] lg:text-4xl text-custom-maroon font-poppins font-semibold sm:mt-6 mt-4 leading-[1.3]">
            {mainSection?.name}
          </h2>

          <p className="text-md md:text-[1vw] lg:text-base text-custom-brown mb-3 mt-4 xs:text-xs">
            {parse(mainSection?.shortDescription || " ")}
          </p>

          <div className="flex items-center text-gray-600">
            <div className="pr-2 text-custom-gray">
              <FmdGoodOutlinedIcon />
            </div>
            <h1 className="font-poppins font-medium text-sm text-custom-light-brown">
              <span className="pr-2">{location.address}</span>
              <span>{location.pincode}</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
